import { apiClient } from './client';

export type SearchEntity = 'ticket' | 'contact' | 'organization' | 'deal' | 'conversation';

export interface SearchHit {
  id: string;
  type: SearchEntity;
  title: string;
  subtitle?: string;
  /** Ticket or CRM number, shown monospace ahead of the title. */
  ref?: string;
  link: string;
  at?: string;
}

export interface SearchGroup {
  type: SearchEntity;
  label: string;
  hits: SearchHit[];
}

export const searchApi = {
  /** Staff-only: the server refuses this for customer-role members. */
  search: async (q: string, types?: SearchEntity[]): Promise<{ query: string; total: number; groups: SearchGroup[] }> => {
    const { data } = await apiClient.get('/search', {
      params: { q, ...(types?.length && { types: types.join(',') }) },
    });
    return data.data;
  },
};
